import { FormattedMessage } from "react-intl";
import HubIcon from "../assets/icons/hub.svg";

const icons = {
  hub: () => <img src={HubIcon} alt="hub icon" />,
};

const hub = {
  id: "hub",
  title: <FormattedMessage id="hub" />,
  type: "group",
  url: "/hub",
  icon: icons.hub,
};

export default hub;
